module.exports = __webpack_public_path__ + "static/img/2.b102855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/2.png
// module id = x0vX
// module chunks = 0